import { render, staticRenderFns } from "./StripePayment.vue?vue&type=template&id=b82d4dea&scoped=true&"
import script from "./StripePayment.vue?vue&type=script&lang=js&"
export * from "./StripePayment.vue?vue&type=script&lang=js&"
import style0 from "./StripePayment.vue?vue&type=style&index=0&id=b82d4dea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82d4dea",
  null
  
)

export default component.exports